import React from "react";
import attachImg from "../../img/attachImg.png";

export const AttachIcon = () => {
  return (
    <>
      <img src={attachImg} className="df-attach-img" />
    </>
  );
};
